module.exports = __webpack_public_path__ + "static/img/FuZhuang_yingtao_spring.7050cbb8.png";